import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities' 

class ConsiderationRepository {

    constructor() {
        this.basePath = store.state.backend;
    }

    getConsiderationsByUser(userId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/considerations/by-user/${userId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getConsiderationsPerTrade(tradeId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/consideration-trades/by-trade/${tradeId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    createConsideration(consideration) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/considerations`, consideration,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    editConsideration(consideration) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/ext/considerations`, consideration,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    deleteConsideration(considerationId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/ext/considerations?considerationId=${considerationId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    assignConsideration(considerationTrade) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/consideration-trades/assign`, considerationTrade,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    removeConsideration(considerationTrade) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/consideration-trades/remove`, considerationTrade,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }
}

export default new ConsiderationRepository();
